import { apiSlice } from "../../../api/ApiService";
const updatePatientDetailsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    updatePatientDetails: builder.mutation({
      query: ({ body, accessToken }) => ({
        url: `/api/v1/Administration/manage-patient`,
        method: "PUT",
        data: body,
        headers: {
          accept: "*/*",
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      }),
      invalidatesTags: [{ type: "PatientList" }],
    }),
  }),
  overrideExisting: false,
});

export const { useUpdatePatientDetailsMutation } = updatePatientDetailsApi;
export default updatePatientDetailsApi;
